import styled from 'styled-components';
import { SkeletonSurface } from 'components/Skeleton/styled';

export const CardWrapper = styled(SkeletonSurface).attrs({})`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CardHeader = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CardBody = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CardFooter = styled.div.attrs({})`
  display: flex;
  justify-content: flex-end;
`;
